module.exports = __webpack_public_path__ + "images/landing/video-previews/social_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/social_2x.jpg
// module id = 4rgK
// module chunks = 1